export const deliverabilityPostmasterAppGroupIdIpReputation =
  "/deliverability/postmaster/:app_group_id/ip_reputation";
